<div class="employees">
  <div
    *ngFor="let employee of employees; let i = index"
    class="employee-card-container"
  >
    <div class="employee-name pl-2">{{ employee.name }}</div>
    <div class="employee-role pl-2">{{ employee.jobTitle }}</div>
    <div class="bottom-row">
      <app-button
        [buttonColor]="'yellow'"
        [buttonType]="'link'"
        [buttonText]="'read more'"
        [buttonIcon]="'chevronright'"
        data-toggle="modal"
        [attr.data-target]="'#employee-' + i"
      ></app-button>
      <img
        class="social-link"
        (click)="goToSocial(i)"
        (click)="sendToGa('Went to ' + employee.name + ' LinkedIn', 'About')"
        src="/assets/img/static-pages/medigi/v2-images/company-logos/linkedin-button-green.svg"
        alt="LinkedIn"
      />
    </div>
  </div>
</div>

<div *ngFor="let employee of employees; let i = index">
  <div
    class="modal fade"
    [attr.id]="'employee-' + i"
    data-keyboard="false"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="top-row">
          <img
            class="close-icon m-2"
            data-dismiss="modal"
            aria-label="Close"
            src="/assets/img/static-pages/medigi/v2-images/standalone-icons/close-icon.svg"
            alt=""
          />
        </div>
        <div class="modal-body">
          <div class="main-content">
            <div class="modal-employee-role">{{ employee.jobTitle }}</div>
            <div class="modal-employee-name">{{ employee.name }}</div>
            <div>
              <p class="modal-employee-desc">{{ employee.description }}</p>
            </div>
            <div>
              <img
                class="social-link"
                (click)="goToSocial(i)"
                (click)="
                  sendToGa('Went to ' + employee.name + ' LinkedIn', 'About')
                "
                src="/assets/img/static-pages/medigi/v2-images/company-logos/linkedin-button-green.svg"
                alt="LinkedIn"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
